import qs from 'qs'
import { useCallback, useEffect, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

type paramType = Record<string, string | number | undefined>

export function useHandleQuery() {
  const history = useHistory()
  const location = useLocation()

  const modQuery = useCallback((params: paramType) => {
    let query = qs.parse(location.search.slice(1)) as paramType
    query = {
      ...query,
      ...params,
    }
    history.replace(`${location.pathname}?${qs.stringify(query)}`)
  }, [history, location.pathname, location.search])

  const replaceQuery = useCallback((params: paramType) => {
    history.replace(`${location.pathname}?${qs.stringify(params)}`)
  }, [history, location.pathname])
  const getQuery = useCallback(() => qs.parse(location.search.slice(1)), [location])
  return {
    modQuery,
    replaceQuery,
    getQuery,
  }
}

export function usePrevious<T>(value: T) {
  const ref = useRef<T>()

  useEffect(() => {
    ref.current = value
  }, [value])

  return ref.current
}
